import { Box, Grid, Paper, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { Breads } from 'src/components/atoms/BreadCrumbs'
import { type HelpContent, helpContents } from './contents/contents'

export const HelpPage = () => {
  return (
    <Box>
      <Breads breadIds={['help']} />
      <Stack spacing={2}>
        <Typography variant="h5">ヘルプ</Typography>
        <Grid container spacing={2}>
          {helpContents.map((v) => (
            <HelpContentItem content={v} key={v.id} />
          ))}
        </Grid>
      </Stack>
    </Box>
  )
}

const HelpContentItem = ({ content }: { content: HelpContent }) => {
  return (
    <Grid size={6}>
      <Link to={`/help/${content.id}`} style={{ textDecoration: 'none' }}>
        <Paper
          elevation={3}
          sx={{
            padding: 2,
            transition: 'box-shadow 0.2s',
            '&:hover': {
              boxShadow: 8,
            },
          }}
        >
          <Typography>
            <b>{content.title}</b>
          </Typography>
          <Typography
            sx={{
              mt: 2,
            }}
          >
            {content.summary}
          </Typography>
        </Paper>
      </Link>
    </Grid>
  )
}
